import React from 'react';
import styled from 'styled-components';

const ButtonAnular = styled.button`
  border: 1px solid #5b36f2;
  align-items: center;
  // background-color: #ffffff;
  padding: 9px 0px;
  margin: 12px 0px 20px 0px;
  border-radius: 4px;
  width: 130px;

  p {
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    color: #5b36f2;
  }
`;

const ContainerBtn = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

const ButtonCancelRequest = (props: any) => {
  const { handlerShowAnulate } = props;
  return (
    <ContainerBtn>
      <ButtonAnular onClick={handlerShowAnulate} data-testid="btn-anulate">
        {' '}
        <p>Anular Solicitud</p>{' '}
      </ButtonAnular>
    </ContainerBtn>
  );
};

export default ButtonCancelRequest;
